<template>
  <b-form id="login" autocomplete="on">
      <b-form-group label-for="gender" label="Anrede">
        <b-form-select id="gender" v-model="registration.gender" :options="genderOptions" autocomplete="sex"/>
        <b-form-invalid-feedback>Bitte wählen Sie eine Andrede</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label-for="firstname" label="Vorname">
        <b-form-input type="text" id="firstname" v-model="registration.firstname" autocomplete="given-name"/>
        <b-form-invalid-feedback>Bitte tragen Sie Ihren Vornamen ein</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label-for="lastname" label="Nachname">
        <b-form-input type="text" id="lastname" v-model="registration.lastname" autocomplete="family-name"/>
        <b-form-invalid-feedback>Bitte tragen Sie ihren Nachnamen ein</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label-for="email" label="Email" v-if="typeof registration.email != 'undefined'">
        <b-form-input type="text" id="email" v-model="registration.email" autocomplete="email"/>
      </b-form-group>

      <b-form-group label-for="password" label="Passwort wählen" description="*Mindestens 8 Zeichen">
        <b-form-input type="password" id="password" v-model="registration.password" autocomplete="new-password"/>
      </b-form-group>

      <b-button type="button" v-on:click="send" variant="primary" class="float-right">Registrieren</b-button>

  </b-form>
</template>

<script>
export default {
  name: 'RegistrationForm',
  props: ['registration'],

  data: function () {
    return {
      genderOptions: [
        {value: 'female', text: 'Frau'},
        {value: 'male', text: 'Herr'}
      ]
    }
  },

  methods: {
    send: function () {
      this.$parent.send()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/guests/registration/Form.vue